mutation RevealAssetSecret($id: ID!, $reason: String!) {
  revealAssetSecret(input: { id: $id, reason: $reason }) {
    secretValue
    secret {
      id
      reveals {
        id
        revealedByName
        reason
        createdAt
      }
    }
  }
}
